var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoyalty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "be90c606-e40b-4210-8fc9-cb3cf50de318",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 262 258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a0bbd21a-1281-4480-a61a-964f43d86754,.e33009be-5fc2-40e8-a65b-8b0e4b80c55a{fill:none;}.ed3bedd7-812d-43d4-a60f-f2e7115b105c{clip-path:url(#f2d4cc35-9692-4183-ae73-1ce1178ecd22);}.a4bd6a15-d7e6-4d46-a3a8-ec11710b85cb{clip-path:url(#ed59a60d-1fa3-479e-9da7-f4a207719d16);}.ba6ab87b-7809-47de-986c-7fd591dbbcd1{fill:#0042e4;}.e33009be-5fc2-40e8-a65b-8b0e4b80c55a{stroke:#262626;stroke-miterlimit:10;}.b77bbf34-3b2a-42af-907d-54de0f7ee1c0{clip-path:url(#bbbfdfdf-3768-4cd4-99ca-d04dffa6ba4c);}.b795cbd3-0a1c-49bf-8cd0-9dc44b52bc10{fill:#fff;}.a2251bd7-99e3-41bc-9cab-ce5bcaad9646{clip-path:url(#a5e29bc0-3963-4839-a723-22f3ff06523d);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "f2d4cc35-9692-4183-ae73-1ce1178ecd22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a0bbd21a-1281-4480-a61a-964f43d86754",
    width: 262,
    height: 258
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ed59a60d-1fa3-479e-9da7-f4a207719d16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a0bbd21a-1281-4480-a61a-964f43d86754",
    x: 50.02,
    y: 48.02,
    width: 162,
    height: 162,
    rx: 4.5,
    transform: "translate(-42.38 190.22) rotate(-64)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbbfdfdf-3768-4cd4-99ca-d04dffa6ba4c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a0bbd21a-1281-4480-a61a-964f43d86754",
    d: "M138.47,99.43v0l6.86,43.67-30.77,17.1-8.72-55.55a16.53,16.53,0,0,1,32.63-5.26Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a5e29bc0-3963-4839-a723-22f3ff06523d"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a0bbd21a-1281-4480-a61a-964f43d86754",
    cx: 161.22,
    cy: 116.73,
    r: 12.59
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ed3bedd7-812d-43d4-a60f-f2e7115b105c"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a4bd6a15-d7e6-4d46-a3a8-ec11710b85cb"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "ba6ab87b-7809-47de-986c-7fd591dbbcd1",
    points: "93.72 20.71 239.33 91.72 168.31 237.33 22.71 166.31 93.72 20.71"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e33009be-5fc2-40e8-a65b-8b0e4b80c55a",
    d: "M97.77,22.68,235.29,89.75a4.51,4.51,0,0,1,2.07,6L170.29,233.29a4.51,4.51,0,0,1-6,2.07L26.75,168.29a4.51,4.51,0,0,1-2.07-6L91.75,24.75A4.51,4.51,0,0,1,97.77,22.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e33009be-5fc2-40e8-a65b-8b0e4b80c55a",
    d: "M92.7,8,250,84.69a4.49,4.49,0,0,1,2.08,6L175.35,248a4.5,4.5,0,0,1-6,2.08L12,173.35a4.5,4.5,0,0,1-2.07-6L86.69,10A4.5,4.5,0,0,1,92.7,8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b77bbf34-3b2a-42af-907d-54de0f7ee1c0"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "b795cbd3-0a1c-49bf-8cd0-9dc44b52bc10",
    points: "114.57 79.98 164.3 104.23 132.68 169.08 82.95 144.82 114.57 79.98"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a2251bd7-99e3-41bc-9cab-ce5bcaad9646"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "b795cbd3-0a1c-49bf-8cd0-9dc44b52bc10",
    points: "155.42 99.9 178.05 110.94 167.01 133.56 144.39 122.53 155.42 99.9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyalty);
export default __webpack_public_path__ + "static/media/loyalty.5f353dfbdb8b5d6eb23925639534aa5f.svg";
export { ForwardRef as ReactComponent };